<template>
  <div class="floating-window" :class="{ expanded: isExpanded }">
    <!-- 收起状态 -->
    <div v-if="!isExpanded" class="floating-collapsed cursor-pointer" @click="toggleExpand">
      <button class="toggle-btn">
        展开
      </button>
    </div>

    <!-- 展开状态 -->
    <div v-else class="floating-expanded">
      <div class="floating-content">
        <div
          v-for="(item, index) in links"
          :key="index"
          class="floating-item"
          @click="handleLinkClick(item)"
        >
          <div class="item-icon">
            <i :class="item.icon"></i>
          </div>
          <div class="item-text">{{ item.text }}</div>
        </div>
        <button class="toggle-btn expand-btn" @click="toggleExpand">
          收起
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingWindow',
  data() {
    return {
      isExpanded: false,
      links: [
        {
          text: '软件产业大脑',
          icon: 'fa fa-lightbulb-o',
          url: '#'
        },
        {
          text: '工业产业大脑',
          icon: 'fa fa-cogs',
          url: '#'
        },
        {
          text: '数智化大模型',
          icon: 'fa fa-microchip',
          url: '#'
        }
      ]
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    handleLinkClick(item) {
      // 这里可以添加具体的跳转逻辑
      window.location.href = item.url
    }
  }
}
</script>

<style scoped>
.floating-window {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

/* 收起状态 */
.floating-collapsed {
  display: none;
}

/* 展开状态 */
.floating-expanded {
  width: 110px;
  background-color: white;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.floating-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 8px;
}

.floating-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 10px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.floating-item:hover {
  color: #409eff;
}

.item-icon {
  width: 35px;
  height: 35px;
  background-color: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  color: white;
  font-size: 18px;
}

.item-text {
  font-size: 12px;
  font-weight: 400;
  color: #303133;
  text-align: center;
}

.toggle-btn {
  width: 100%;
  padding: 8px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: background-color 0.2s ease;
}

.toggle-btn:hover {
  background-color: #66b1ff;
}

.expand-btn {
  margin-top: 8px;
}

.floating-collapsed .toggle-btn {
  background-color: transparent;
  color: white;
  font-size: 12px;
  width: auto;
  padding: 0;
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 2px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-expanded {
    width: 180px;
  }

  .item-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .item-text {
    font-size: 12px;
  }
}
</style>
